<template>
      
  <div class="container mt-5">
   
   <div class=" mt-4"
     style="">
     <a class="aru" :href="baseUrl">
       <img  :src="'/imgs/aruvaa_logo.png'" alt="" class="my-2 img_size" />
     </a>
   </div>

   <div
     class="block w-1/2 rounded-lg px-5 py-5 mt-4 success shadow-sm"
     style="background-color: #F9FFFE"
   >
 
   <div class="text-center place-content-center">
              <img
              :src="'/imgs/tick.png'"
              alt="Update"
              class="inline"
              
              />
              <br />
              <h4 class="text-center update font-semibold mt-5"> Thank You !</h4>
              <div class="text-center mb-4">
              <div class=" inline-block  mx-auto">
                  <p class="text-sm font-semibold text-center mx-auto text-gray-700" style="width:">
                      This is Testing Tenant-setup page
                  </p>
                  <p class="text-xs font-semibold text-center mx-auto text-gray-700" style="width:">
                      Click below to use the product.
                  </p>
              </div>
          </div class="my-5 justify-center">
          
          <button type="button" style="background-color:#57A777" class="rounded font-bold  text-white px-4 py-2 my-3"  
        >
          <a v-bind:href="mainUrl" class="text-white no-underline"
            >Proceed</a>
        </button>
         
          </div>   
   </div>
 </div>
  
</template>

<script>

export default {
  props: {
    productName: String,
    tenantHostName: String,
  },
   data() {
    return {
        mainUrl: this.$utils.goToUrl( this.tenantHostName + "/dashboard"),
    };
  },
components: {

},
methods: {

},
mounted(){
console.log("dashboard resirect"  + this.mainUrl);
},

}

</script>

<style>
.success {
margin: auto;
}
.aru{
display: block;
margin-left: auto;
margin-right: auto;
width: 13%;
margin-top:70px;
}
.img_size {
height: auto;
width: 176px;
}
p {
margin-top: 0;
margin-bottom: 0.1rem;
}
.skip:hover{
color:#488c63 !important;
}

</style>